<template>
    <div>
<!--        <el-button class="w-full bg-navy text-white border-0 py-3 text-sm-scale font-normal" size="small"
                   @click="onTest">
            Pay Now
        </el-button>-->
<!--        <el-button @click="dialogPayment=true">Open</el-button>-->
        <form method="POST" target="aba_webservice" action="https://checkout.payway.com.kh/api/payment-gateway/v1/payments/purchase" id="aba_merchant_request">
            <input type="hidden" name="hash" :value="payForm.payway_hash" id="hash"/>
            <input type="hidden" name="tran_id" :value="payForm.tran_id" id="tran_id"/>
            <input type="hidden" name="continue_success_url" :value="payForm.continue_success_url"/>
            <input type="hidden" name="return_url" :value="payForm.return_url"/>
            <input type="hidden" name="return_params" :value="payForm.return_params"/>
            <input type="hidden" name="merchant_id" :value="payForm.amount"/>
            <input type="hidden" name="req_time" :value="payForm.req_time"/>
            <input type="hidden" name="amount" :value="payForm.amount" id="amount"/>
            <input type="hidden" name="payment_option" :value="payForm.payment_option"/>
            <input type="hidden" name="merchant_id" value="peopleandpartners"/>
            <input type="hidden" name="view_type" value="checkout"/>
        </form>
        <el-dialog
            @closed="(()=>{this.abaPayway='';this.stopChecking()})"
            :visible.sync="dialogKHQR"
            class="dialog-wrapper"
            custom-class="dialog-aba"
            :lock-scroll="true"
            :append-to-body="true"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <template slot="title">
                <div class="flex justify-between items-center p-2">
                    <div></div>
                    <el-button @click="dialogKHQR=false" size="small" class="text-navy bg-secondary-light hover:bg-gray-100 p-1 rounded-full" type="text"><i class="las la-times text-lg-scale"></i></el-button>
                </div>
            </template>
            <div class="py-3">
                <div class="flex justify-center">
                    <div  ref="htmlContent" class="bg-no-repeat bg-contain bg-center relative" style="height: 440px;width: 320px ;background-image: url('/img/khqr-wrapper.svg')">
                        <div class="absolute left-10 text-left top-20 text-dark">
                            <h4 class="mb-0 mt-1 font-normal text-black">People & Partners Ins.</h4>
                            <h2 class="my-1 text-black">{{formData.total_premium?formData.total_premium.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }):'0.00'}} <span class="text-xs font-normal"> USD</span></h2>
                        </div>
                        <div v-if="qr_blob" class="absolute bottom-6 inset-x-0">
                            <img width="240" :src="qr_blob" alt="">
                        </div>
                        <div v-if="qr_blob" class="absolute inset-x-0 bottom-32">
                            <img width="30" src="/img/dollar.svg" alt="">
                        </div>
                        <div class="absolute bottom-6 inset-x-0" style="height: 240px;width: 100%; z-index: 1"></div>
                    </div>

                </div>
                <p class="mx-10">Scan with Mobile Banking App supporting KHQR or <a class="text-navy font-semibold hover:text-primary-400" :href="qr_blob" download="khqr_code.png">Download here!</a></p>
            </div>
<!--            <div class="">
                <img class="w-full border-0" src="/img/khqr-wrapper.svg" alt="">

            </div>-->
<!--
            <img class="w-full border-0" :src="qr_blob" alt="">
-->
<!--            <iframe  height="590" ></iframe>-->
        </el-dialog>



        <el-dialog
            :show-close="false"
            :lock-scroll="true"
            :visible.sync="dialogPayment"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            class="dialog-wrapper"
            custom-class="dialog-scan"
            center
            :append-to-body="true"
        >
            <template slot="title">
                <div class="flex justify-between items-center p-3 xs:p-4">
                    <span class="text-navy text-lg-scale font-semibold">Payment Methods</span>
                    <!--                    <el-button @click="dialogPlans=false" type="text" size="small" class="p-0 text-navy"><i class="el-icon-close text-lg-scale"></i></el-button>-->
                    <el-button :disabled="spin.method" @click="dialogPayment=false" size="small" class="text-navy bg-secondary-light hover:bg-gray-100 p-1 rounded-full" type="text"><i class="las la-times text-lg-scale"></i></el-button>

                </div>
            </template>
            <div class="m-3 xs:m-4 mt-0 xs:mt-0">
                <el-radio-group :disabled="spin.method" class="w-full" v-model="payForm.payment_option">
                    <!--                <el-radio disabled-->
                    <!--                          class="border border-1 w-100 p-3 bg-secondary-light mt-2 mx-0 d-flex shadow-lg&#45;&#45;hover position-relative h-auto align-items-center"-->
                    <!--                          label="abapay_khqr" border>-->
                    <!--                    <div class="d-flex text-navy">-->
                    <!--                        <div class="d-flex">-->
                    <!--                            <img :width="52" src="/img/amk-logo.png">-->
                    <!--                            <div class="ml-2">-->
                    <!--                                <span class="text-sm-scale font-weight-bold d-flex align-items-center">ABA KHQR</span>-->
                    <!--                                <span-->
                    <!--                                    class="text-xs-scale d-flex align-items-center">Scan to pay with member bank app</span>-->
                    <!--                            </div>-->

                    <!--                        </div>-->
                    <!--                    </div>-->
                    <!--                    <div style="position: relative; width: 45px; height: 45px; overflow: hidden;"-->
                    <!--                         class="position-absolute right-0 top-0">-->
                    <!--                        <div-->
                    <!--                            style="position: absolute; width: 100%; height: 100%; background-color: var(&#45;&#45;navy); transform: skew(47deg); transform-origin: top right;"></div>-->
                    <!--                        <img style="position: relative; z-index: 1; right: -22px;top:3px" :width="20"-->
                    <!--                             src="/img/block.svg">-->
                    <!--                    </div>-->
                    <!--                </el-radio>-->
                    <el-radio v-for="(item,i) in payments" :key="i"
                        class="border border-1 hover:bg-gray-100 active:bg-gray-100 p-3 mx-0 mt-1 flex relative h-auto items-center"
                        :label="item.value" border>
                        <div class="flex text-navy w-full">
                            <div class="flex">
                                <img :width="38" :src="item.icon">
                                <div class="ml-2 mt-1">
                                <span
                                    class="text-sm-scale font-semibold flex items-center">{{item.title}}</span>
                                    <span class="text-xs-scale flex items-center">{{item.sub_title}}</span>
                                    <!--                                <span class="text-xs-scale d-flex align-items-center"><img :width="'auto'"-->
                                    <!--                                                                                           src="/img/all-card.svg"></span>-->
                                </div>
                            </div>
                        </div>
                    </el-radio>
<!--                    <el-radio
                        class="border border-1 hover:bg-gray-100 active:bg-gray-100 p-3 mt-2 mx-0 flex relative h-auto items-center"
                        label="cards" border>
                        <div class="flex text-navy w-full">
                            <div class="flex">
                                <img :width="38" src="/img/aba-logo.jpg">
                                <div class="ml-2 mt-1">
                                <span
                                    class="text-sm-scale font-semibold flex items-center">ABA KHQR</span>
                                    <span class="text-xs-scale flex items-center">Scan to pay with member bank app</span>
                                    &lt;!&ndash;                                <span class="text-xs-scale d-flex align-items-center"><img :width="'auto'"&ndash;&gt;
                                    &lt;!&ndash;                                                                                           src="/img/all-card.svg"></span>&ndash;&gt;
                                </div>
                            </div>
                        </div>
                    </el-radio>-->
                </el-radio-group>
                <div class="flex justify-end mt-3 xs:mt-4">
                    <el-button :loading="spin.method" :disabled="!payForm.payment_option" @click="onRequestQr" size="small"
                               style="padding: 12px 25px" class="border-0 bg-navy font-medium text-white text-sm-scale">
                        Checkout
                    </el-button>
                </div>
            </div>

        </el-dialog>
        <DialogMessage ref="dialogMessageRef"/>
    </div>
</template>

<script>


export default {
    name: "DialogPayment",
    props: ['formData'],

    data() {
        return {
            dialogPayment: false,
            dialogKHQR: false,
            abaPayway: '',
            qr_blob: '',
            payForm : {
                payway_hash:'',
                tran_id:'',
                amount:'',
                req_time:'',
                payment_option:'',
                return_url:'',
                return_params:'',
                merchant_id: 'peopleandpartners',
                continue_success_url: window.location.toString(),
            },
            payments: [
                {
                    //method:'ABA KHQR',
                    value:'abapay_khqr',
                    method:'ABA',
                    title:'ABA KHQR',
                    sub_title:`Scan to pay with any banking app`,
                    icon:'/img/aba-khqr.svg',
                },
                {
                    //method:'ABA KHQR',
                    value:'amk',
                    method:'AMK',
                    title:'AMK KHQR',
                    sub_title:'Scan to pay with any banking app',
                    icon:'/img/amk-logo.png',
                },

            ],
            paymentMethod: '',
            payment_chosen : {},
            spin: {
                method: false,
            },
            intervalId: null,
            timeoutId: null,
        }
    },
    components: {
        DialogMessage: () => import('@/Components/DialogMessage')
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
        clearInterval(this.intervalId);
        clearTimeout(this.timeoutId);
    },
    methods: {
        onGetHash() {
            return new Promise((resolve, reject) => {
                //const tran_id =  Math.floor(1000000 + Math.random() * 9000000);
                this.payForm.tran_id = this.payForm.tran_id.replace(/\//g, "-");
                //this.payForm.amount = 0.01;
                this.payForm.req_time = this.$moment().format('YYYY-MM-DD-HH:mm:ss');
                this.$inertia.post('/products/payway/hash', {
                    'tran_id': this.payForm.tran_id,
                    'amount': this.payForm.amount,
                    'req_time': this.payForm.req_time,
                    'payment_option': this.payForm.payment_option,
                    'return_url': this.payForm.return_url,
                    'continue_success_url': this.payForm.continue_success_url,
                    'return_params': this.payForm.return_params,
                }, {
                    preserveScroll: true,
                    onSuccess: (data) => {
                        this.payForm.payway_hash = data.props.flash.data;
                        resolve(); // Resolve the promise when successful
                    },
                    onError: (error) => {
                        //console.error('Error fetching PayWay hash:', error);
                        reject(error); // Reject the promise with the error
                    },
                });
            });
        },

        async ABA_KHQR() {
            try {
                // Assuming AbaPayway is globally available
                await this.onGetHash();
                AbaPayway.checkout();
            } catch (error) {
                //console.log('Error handling checkout');
            }
        },
        onTest(){
            this.spin.method = true;
            this.$inertia.post('/paid', {
            }, {
                preserveScroll: true,
                onSuccess: (data) => {
                   const status = data.props.flash.data;
                    setTimeout(() => {
                        this.$refs.dialogMessageRef.onOpenMessage("/img/upload-check.png", `<p class="text-success font-semibold text-md-scale">Recently, payment was successful!</p>
                                    <p class="text-navy text-sm-scale text-break mt-3">Thank you for choosing our services.<br>Kindly check your email : "<b class="font-weight-bold">${this.$parent.formData.email??''}</b>" for your insurance document.</p>`, '', true);
                    }, 250);
                    this.onClearForm();
                    this.spin.method =  this.dialogPayment =   false;
                },
                onError: (error) => {
                    //console.error('Error fetching PayWay hash:', error);
                    this.spin.method = this.dialogPayment = false;
                    reject(error); // Reject the promise with the error
                },
            });
            this.spin.method =  this.dialogPayment =   false;
        },
        async onOpenPayment() {
            this.payForm.payment_option = '';
            this.$inertia.post('/products/check', {
                // Include your payload here
                valid:this.$parent.formData.valid_coupon === 1 ? 1:'',
            }, {
                preserveScroll: true,
                onSuccess: (data) => {
                    if (data.props.flash.error) {
                        this.dialogPayment = this.$parent.spin.payment = false;
                    } else {
                        let status = data.props.data;
                        if (status && status.is_paid) {
                            setTimeout(() => {
                                this.$refs.dialogMessageRef.onOpenMessage("/img/upload-check.png", `<p class="text-success font-semibold text-md-scale">Recently, payment was successful!</p>
                                    <p class="text-navy text-sm-scale text-break mt-3">Thank you for choosing our services.<br>Kindly check your email : "<b class="font-weight-bold">${status.email ?? ''}</b>" for your insurance document.</p>`, '', true);

                            }, 250);
                            this.onClearForm();

                        } else {
                            this.dialogPayment = true;
                        }
                    }
                    this.$parent.spin.payment = false;
                },
                onError: (error) => {
                    this.dialogPayment = this.$parent.spin.payment = false;
                },
            })
        },
        startChecking() {
            this.onCheckPayment(); // Check status immediately
            const checkInterval = async () => {
                await this.onCheckPayment(); // Check status
                this.timeoutId = setTimeout(checkInterval, 5000); // Schedule the next check after 5 seconds
            };
            this.timeoutId = setTimeout(() => {
                clearInterval(this.intervalId);
                clearTimeout(this.timeoutId);
                this.dialogKHQR = false;
                /*setTimeout(() => {
                    this.$refs.dialogMessageRef.onOpenMessage('/img/error.png', `<p class="text-danger font-medium text-md-scale">Sorry... <br>Your payment session has timed out.</p>`)
                }, 250)*/
//185000
            }, 300000);
            checkInterval();
        },// Stop checking after  3min
        stopChecking() {
            clearInterval(this.intervalId);
            clearTimeout(this.timeoutId);
            this.dialogKHQR = false;
        },
        async onRequestQr() {
            try {
                this.$parent.spin.payment = false
                this.spin.method = true;
                await new Promise((resolve, reject) => {

                    this.$inertia.post(
                        '/products/request/qr',
                        {
                            method:this.payForm.payment_option
                        },
                        {
                            preserveScroll: true,
                            onSuccess: (data) => {
                                if(data.props.flash.error){
                                    reject(new Error (data.props.flash.error))
                                }else {
                                    this.$inertia.post(`/drive/upload`, this.$parent.formData.files_raw, {
                                        headers: {
                                            "Content-Type": "multipart/form-data"
                                        },
                                        preserveScroll: true,
                                        onSuccess: (upload) => {
                                            if (upload.props.flash.error) {
                                                console.log(upload.props.flash.error)
                                                reject(new Error(upload.props.flash.error))
                                            } else {
                                                this.dialogPayment =  this.spin.method =  false;
                                                if(this.payForm.payment_option === 'amk'){
                                                    this.qr_blob = data.props.flash.data;
                                                }else{
                                                    this.payForm.tran_id =data.props.flash.data.quote_no;
                                                    this.payForm.amount = data.props.flash.data.amount;
                                                    this.payForm.return_params = JSON.stringify({
                                                        tran_id: this.payForm.tran_id,
                                                    });
                                                    this.payForm.return_url = btoa(`https://buynow.peoplenpartners.net/api/paid`);
                                                    this.ABA_KHQR();
                                                }
                                                if(this.payForm.payment_option === 'amk'){
                                                    setTimeout(() => {
                                                        this.dialogKHQR = true;
                                                    }, 250);
                                                    this.startChecking();
                                                }
                                                // this.$refs.dialogMessageRef.onOpenMessage("/img/loading.gif", `<p class="text-navy font-medium text-md-scale">Uploading...</p>`,'loading',false);
                                                resolve(upload.props.flash.success);
                                                resolve(upload);
                                            }
                                        },
                                        onError: (e) => {
                                            reject(new Error('Upload failed'));
                                        }
                                    })

                                }
                            },
                            onError: () => {
                                reject(new Error('Request failed')); // Reject the promise on error
                            },
                        }
                    );
                });
                this.$parent.spin.payment = this.spin.method = false;
            }catch (e) {
                this.$parent.spin.payment = this.spin.method = false;
                setTimeout(() => {
                    this.$refs.dialogMessageRef.onOpenMessage('/img/error.png', `<p class="text-danger font-medium text-md-scale">Oops... <br> Something went wrong!</p>`,'',true)
                }, 250)
            }
        },
        /*async onCheckPayment() {
            if (!this.dialogKHQR) return;
            try {
                await new Promise(async (resolve, reject) => {
                    let res = await this.$inertia.post('/products/check', {}, {
                        preserveScroll: true,
                        onSuccess: (data) => {
                            if (data.props.flash.error) {
                                reject(new Error(data.props.flash.error))
                            } else {
                                let status = data.props.flash.data;
                                if (status && status.is_paid) {
                                    this.stopChecking();
                                    window.location.reload();
                                    resolve(status);
                                }
                            }
                        },
                        onError: (error) => {
                            reject(new Error(`Error during payment check`));
                        },
                    });
                    resolve(res);
            });
            } catch (error) {
                this.stopChecking();
            }
        },*/
        async onCheckPayment() {
            if (!this.dialogKHQR) return;
            try {
                let data = await this.$inertia.post('/products/check', {}, {
                    preserveScroll: true,
                    onSuccess: (data) => {
                        if (data.props.flash.error) {
                            throw new Error(data.props.flash.error);
                        } else {
                            let status = data.props.flash.data;
                            if (status && status.is_paid) {

                                window.location.reload();
                                this.stopChecking();
                                return status;
                            }
                        }
                    },
                    onError: (error) => {
                        throw new Error(`Error during payment check`);
                    },
                });
                return data;
            } catch (error) {
                this.stopChecking();
                throw error; // Rethrow the error to handle it upstream
            }
        },

        onClearForm(){
            this.$parent.step = 0;
            this.$parent.formItems = [];
            this.$parent.formData={
                dob: null,
                passport_no: '',
                gender: '',
                nationality: '',
                travel_country: [],
                quote_items: [],
                share_with: [],
                beneficiary_name: '',
                email: '',
                phone: '',
                full_address: '',
                premium: '$0.00',
                image: '',
                required: '',
                imageRaw: '',
                terms: '',

                policy_type_id: '',
                policy_type: '',
                insured_name:'',
                insured_name_kh:'',
                issued_by_en:'',
                issued_by_kh:'',
                type: '',
                period: '',
                period_from:'',
                period_to:'',
                issued_date:'',
                status: 0,
                purpose_of_use:'',
                scope_of_cover: '',
                options:'',
                total_premium: '',
                old_total_premium:'',
                files_raw:[],
                id_card: 0,
                pob: '',
                optionals: [],
            };
        }

    },
}
</script>

<style scoped>
.el-radio.is-bordered.is-checked {
    border-color: #dcdfe6;
    background-color: rgba(228,229,233,var(--tw-bg-opacity)) !important;
    --tw-bg-opacity: 1 !important;
}
.khqr-wrapper{
    background-size: cover;
    background-image: url("/img/khqr-wrapper.svg");
}
div >>>.dialog-scan .el-dialog__header {
    padding: 0;
}
div >>> .dialog-aba, div >>> .dialog-payment,div >>>.dialog-scan {
   /* width: 360px;*/
    width: 95%;
}

div >>> .dialog-aba .el-dialog__header {
    padding: 3px;
}

div >>> .dialog-aba .el-dialog__body ,div>>>.dialog-scan .el-dialog__body{
    padding: 0;
}
div>>>.el-radio__label{
    line-height: 16px;
}
div >>> .dialog-payment .el-dialog__body {
    padding: 0!important;
}
div >>> .dialog-payment .el-dialog__header {
    padding: 0!important;
}
@media (min-width: 576px) {
    div >>> .dialog-aba {
        /* width: 50% !important;*/
    }
}

@media (min-width: 768px) {
    div >>> .dialog-aba {
        width: 360px;
    }

    div >>> .dialog-payment {
        width: 360px;
    }
    div>>>.dialog-scan{
        width: 55% !important;
    }
}

@media (min-width: 992px) {
    div >>> .dialog-aba {
        /*width: 42% !important;;*/
    }

}

@media (min-width: 1200px) {
    div >>> .dialog-aba {
      /*  width: 30% !important;;*/
    }
    div>>>.dialog-scan{
        width: 35% !important;
    }

}

@media (min-width: 1440px) {
    div >>> .dialog-aba {
       /* width: 25% !important;;*/
    }
    div>>>.dialog-scan{
        width: 32% !important;
    }
}

@media (min-width: 1920px) {
    div>>>.dialog-scan{
        width: 25% !important;
    }

}

@media (min-width: 2500px) {
    div>>>.dialog-scan{
        width: 20% !important;
    }
    div >>> .dialog-aba {
       /* width: 15% !important;;*/

    }
}
</style>
